import React, {useEffect, useState} from 'react';
import {MarketingPreference, membersEmailApi} from '../../services/membersEmailApi.ts';
import {membersError} from '../../services/membersApi.ts';
import {Card, Loading, Notice, primary} from './MembersShared.tsx';

export default function MembersEmailPreferences({csrfToken}: {csrfToken: string}) {
  const [preference, setPreference] = useState<MarketingPreference | null>(null);
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let current = true;
    setLoading(true); setError(''); setSaved(false);
    void membersEmailApi.preference().then(result => {
      if (current) {setPreference(result); setEnabled(result.enabled);}
    }).catch(err => {if (current) {setPreference(null); setError(membersError(err));}}).finally(() => {if (current) setLoading(false);});
    return () => {current = false;};
  }, [retry]);
  async function submit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!preference) return;
    setSaving(true); setError(''); setSaved(false);
    try {
      const result = await membersEmailApi.savePreference({enabled, revision: preference.revision, consent_version: preference.consent_version}, csrfToken);
      setPreference(result); setEnabled(result.enabled); setSaved(true);
    } catch(err) {setError(membersError(err));} finally {setSaving(false);}
  }
  return (
    <Card>
      <h2 className="text-lg font-semibold">Preferências de e-mail</h2>
      <p className="members-secondary my-4 text-sm leading-relaxed">Escolha se deseja receber novidades, conteúdos e ofertas da Sminy. Você pode mudar essa preferência a qualquer momento.</p>
      {loading ? <Loading /> : preference && (
        <form className="space-y-5" onSubmit={submit}>
          <label className="flex items-start gap-3 text-sm leading-relaxed"><input type="checkbox" checked={enabled} disabled={saving || (preference.suppressed && !enabled)} onChange={event => {setEnabled(event.target.checked); setSaved(false);}} className="mt-1 shrink-0" /><span>Quero receber novidades, conteúdos e ofertas por e-mail.</span></label>
          {preference.suppressed && <Notice>Os envios promocionais estão indisponíveis para este endereço. Fale com a Sminy se precisar de ajuda.</Notice>}
          <p className="members-muted text-xs leading-relaxed">Mensagens necessárias para recuperar seu acesso ou acompanhar sua conta continuam separadas dessa preferência.</p>
          <button className={primary} disabled={saving || enabled === preference.enabled}>{saving ? 'Salvando...' : 'Salvar preferência'}</button>
          {saved && <Notice>Preferência atualizada.</Notice>}
        </form>
      )}
      {error && <div className="mt-5"><Notice error>{error} <button className="underline" disabled={saving} onClick={() => setRetry(value => value + 1)}>Atualizar preferência</button></Notice></div>}
    </Card>
  );
}
